import { useCallback, useMemo, useRef, useState } from 'react';

import { OrbitNotice, OrbitNoticeRequest, OrbitNoticeValue } from './OrbitNoticeContext';

/**
 * One notice at a time: the frames draw a single bubble in a fixed slot at the top of the panel
 * body, so a second one replaces the first rather than stacking under it.
 */
const useOrbitNoticeState = (): OrbitNoticeValue => {
  const [notice, setNotice] = useState<OrbitNotice | null>(null);
  // State, not a ref: the host renders nothing until it has the panel node, so it has to re-render
  // when the panel mounts.
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const sequence = useRef(0);

  const showNotice = useCallback((request: OrbitNoticeRequest) => {
    sequence.current += 1;
    setNotice({ ...request, id: sequence.current });
  }, []);

  const dismissNotice = useCallback(() => setNotice(null), []);

  return useMemo(
    () => ({ notice, showNotice, dismissNotice, anchor, setAnchor }),
    [notice, showNotice, dismissNotice, anchor]
  );
};

export default useOrbitNoticeState;
